var CFI = {

  stripAssertions: function(cfi){
    try {
      return cfi.replace(/ *\[[^\]]*\] */g, "");
    } catch (e) {
      // CFI is probably null
      return cfi;
    }
  },

  // Technical term for this is probably "spacial offset"
  stripScrollPosition: function(cfi){
    const scrollIndex = cfi.indexOf('@');
    return scrollIndex >= 0 ? cfi.substring(0, scrollIndex) : cfi;
  },

  triggerCFIChange: function(){
    if (this.cfiChangeCallback){
      this.cfiChangeCallback(Fraction.initialCFI);
    }
  },

  registerCFIChange: function(callback){
    this.cfiChangeCallback = callback;
  },

  unregisterCFIChange: function(){
    this.cfiChangeCallback = undefined;
  },

  /**
   * Look for a cfi match. If not found, get the index that is
   * before the requested cfi
   */
  findIndexMatchingCfiFallBackToBefore: function(
    orderedItems,
    getItemCfi,
    cfi
  ) {
    if (!orderedItems || orderedItems.length === 0 || !cfi) {
      return -1;
    }
    for (let i = 0; i < orderedItems.length - 1; i++) {
      const compare = window.Jigsaw.CFIUtils.compareCFIs;
      const compareThis = compare(cfi, getItemCfi(orderedItems[i]));
      const compareNext = compare(cfi, getItemCfi(orderedItems[i + 1]));
      if (compareThis === 0 || compareNext < 0) {
        return i;
      }
    }
    return orderedItems.length - 1;
  },

  /**
   * Look for a cfi match. If not found, get the index that is
   * after the requested cfi
   */
  findIndexMatchingCfiFallBackToAfter: function(
    orderedItems,
    getItemCfi,
    cfi
  ) {
    if (!orderedItems || orderedItems.length === 0 || !cfi) {
      return -1;
    }
    for (let i = 0; i < orderedItems.length - 1; i++) {
      const compare = window.Jigsaw.CFIUtils.compareCFIs;
      const compareThis = compare(cfi, getItemCfi(orderedItems[i]));
      const compareNext = compare(cfi, getItemCfi(orderedItems[i + 1]));
      if (compareThis === 0) {
        return i;
      } else if (compareNext < 0) {
        return i + 1;
      }
    }
    return orderedItems.length - 1;
  }


};

module.exports = CFI;
